import { ImportPfmsDataComponent } from './components/cao/import-pfms-data/import-pfms-data.component';
import { ReturnToFarmerPfmsReportComponent } from './components/cao/return-to-farmer-pfms-report/return-to-farmer-pfms-report.component';
import { SubsidyToVendorPfmsReportComponent } from './components/cao/subsidy-to-vendor-pfms-report/subsidy-to-vendor-pfms-report.component';
import { SubsidyToFarmerPfmsReportComponent } from './components/cao/subsidy-to-farmer-pfms-report/subsidy-to-farmer-pfms-report.component';
import { ViewFarmerApplicationComponent } from './components/je/view-farmer-application/view-farmer-application.component';
import { HelpdeskComponent } from './components/helpdesk/helpdesk.component';
import { MiPhysicalVerificationsComponent } from './components/je/mi-physical-verifications/mi-physical-verifications.component';
import { AttachmentComponent } from './components/je/attachment/attachment.component';
import { FinanceComponent } from './components/je/finance/finance.component';
import { BasicComponent } from './components/je/basic/basic.component';
import { JeApplicationComponent } from './components/je/je-application/je-application.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { MiVendorApplicationVerificationComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification.component';
import { FarmerApplicationVerificationComponent } from './components/department/farmer-application-verification/farmer-application-verification.component';
import { VendorMiEstimationConsentFormComponent } from './components/department/vendor-mi-estimation-consent-form/vendor-mi-estimation-consent-form.component';
import { PondProgressIntimationComponent } from './components/pond-progress-intimation/pond-progress-intimation.component';
import { VendorGuardGuard } from './guards/vendor-guard.guard';
import { VendorConsentFormComponent } from './components/vendor/vendor-consent-form/vendor-consent-form.component';
import { VendorComponent } from './components/vendor/vendor.component';
import { DepartmentConsentFormComponent } from './components/department/department-consent-form/department-consent-form.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { HomePageLayoutComponent } from './components/layouts/home-page-layout/home-page-layout.component';
import { InnerPageLayoutComponent } from './components/layouts/inner-page-layout/inner-page-layout.component';
import { BankDetailsComponent } from './components/registration/bank-details/bank-details.component';
import { PersonalDetailsComponent } from './components/registration/personal-details/personal-details.component';
import { FarmerLandDetailComponent } from './components/registration/farmer-land-detail/farmer-land-detail.component';
import { OnFarmMiComponent } from './components/registration/on-farm-mi/on-farm-mi.component';
import { LoginComponent } from './components/login/login.component';
import { PhoneLoginComponent } from './components/phone-login/phone-login.component';
import { FarmersApplicationComponent } from './components/application/farmers-application/farmers-application.component';
import { ConsentFormComponent } from './components/application/consent-form/consent-form.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { DepartmentGuardGuard } from './guards/department-guard.guard';
import { JEGuardGuard } from './guards/je-guard.guard';
import { SdoGuardGuard } from './guards/sdo-guard.guard';
import { PondEstimateComponent } from './components/pond-estimate/pond-estimate.component';

import { VendorBOQComponent } from './components/vendor/vendor-boq/vendor-boq.component';
import { MiChallanComponent } from './components/challan/mi-challan/mi-challan.component';
import { FarmerShareComponent } from './components/challan/mi-challan/farmer-share/farmer-share.component';
import { FullPaymentComponent } from './components/challan/mi-challan/full-payment/full-payment.component';
import { SolarChallanComponent } from './components/challan/solar-challan/solar-challan.component';
import { SanctionLetterComponent } from './components/challan/mi-challan/sanction-letter/sanction-letter.component';
import { AuthGuard } from './guards/auth-guard.service';
import { WorkFlowAllStatusComponent } from './components/department/farmer-application-verification/work-flow-all-status/work-flow-all-status.component';
import { LandingComponent } from './components/landing/landing.component';
import { ActivitiesComponent } from './components/activities/activities.component';
import { OrganizationalSetupComponent } from './components/organizational-setup/organizational-setup.component';
import { StatisticsComponent } from './components/statistics/statistics.component';
import { FullPaymentchallanDetailsComponent } from './components/vendor/full-paymentchallan-details/full-paymentchallan-details.component';
import { ReportSummaryComponent } from './components/department/report-summary/report-summary.component';
import { VendorApplicationComponent } from './components/vendor/vendor-application/vendor-application.component';
import { PrintFarmersChallanComponent } from './components/department/print-farmers-challan/print-farmers-challan.component';
import { HelpdeskGuard } from './guards/helpdesk.guard';
import { UpdateMiComponentCmlValidityComponent } from './components/department/update-mi-component-cml-validity/update-mi-component-cml-validity.component';
import { ChangeRequestComponent } from './components/farmer/change-request/change-request.component';
import { ViewFormComponent } from './components/sdo/view-form/view-form.component';
import { SdoComponent } from './components/sdo/sdo.component';
import { FarmerAppChangeRequestComponent } from './components/department/farmer-app-change-request/farmer-app-change-request.component';
import { NewInitiativesComponent } from './components/new-initiatives/new-initiatives.component';
import { RtiComponent } from './components/rti/rti.component';
import { MiSurveyComponent } from './components/department/subsidy-lot/mi-survey/mi-survey.component';
import { MiSurveySubsidyDisbursementComponent } from './components/cao/mi-survey-subsidy-disbursement/mi-survey-subsidy-disbursement.component';
import { ApproveFarmersChallanComponent } from './components/department/approve-farmers-challan/approve-farmers-challan.component';
import { CAOGuardGuard } from './guards/cao-guard.guard';
import { FarmerShareToVendorComponent } from './components/department/subsidy-lot/farmer-share-to-vendor/farmer-share-to-vendor.component';
import { SubsidyToVendorComponent } from './components/department/subsidy-lot/subsidy-to-vendor/subsidy-to-vendor.component';
import { SubsidyToFarmerComponent } from './components/department/subsidy-lot/subsidy-to-farmer/subsidy-to-farmer.component';
import { RefundToFarmerComponent } from './components/department/subsidy-lot/refund-to-farmer/refund-to-farmer.component';
import { FarmerShareToVendorPfmsReportComponent } from './components/cao/farmer-share-to-vendor-pfms-report/farmer-share-to-vendor-pfms-report.component';
import { XenGuardGuard } from './guards/xen-guard.guard';
import { XenComponent } from './components/xen/xen.component';
import { XenFormComponent } from './components/xen/xen-form/xen-form.component';
import { TankStage1Component } from './components/tank-stage1/tank-stage1.component';
import { TankStage2Component } from './components/tank-stage2/tank-stage2.component';
import { TankStage3Component } from './components/tank-stage3/tank-stage3.component';
import { EvaluationStudyComponent } from './components/evaluation-study/evaluation-study.component';
import { MicroIrrigationComponent } from './components/micro-irrigation/micro-irrigation.component';
import { ProjectComponent } from './components/project/project.component';
import { AnnualPlanComponent } from './components/annual-plan/annual-plan.component';
import { AchievementsComponent } from './components/achievements/achievements.component';
import { Tankstagesurvey2Component } from './components/department/subsidy-lot/tankstagesurvey2/tankstagesurvey2.component';
import { Tankstagesurvey3Component } from './components/department/subsidy-lot/tankstagesurvey3/tankstagesurvey3.component';
import { Tankstagesurvey1Component } from './components/department/subsidy-lot/tankstagesurvey1/tankstagesurvey1.component';
import { TankStage1PfmsReportComponent } from './components/cao/tank-stage1-pfms-report/tank-stage1-pfms-report.component';
import { TankStage2PfmsReportComponent } from './components/cao/tank-stage2-pfms-report/tank-stage2-pfms-report.component';
import { TankStage3PfmsReportComponent } from './components/cao/tank-stage3-pfms-report/tank-stage3-pfms-report.component';
import { ViewCoOrdinatesComponent } from './components/department/view-co-ordinates/view-co-ordinates.component';
import { DepartmentDashboardComponent } from './components/department/department-dashboard/department-dashboard.component';
import { AppVerificationReportComponent } from './components/department/reports/app-verification-report/app-verification-report.component';
import { MonthWiseReportComponent } from './components/department/reports/app-verification-report/month-wise-report/month-wise-report.component';
import { DistrictWiseReportComponent } from './components/department/reports/app-verification-report/district-wise-report/district-wise-report.component';
import { UserWiseReportComponent } from './components/department/reports/app-verification-report/user-wise-report/user-wise-report.component';
import { VendorWiseReportComponent } from './components/department/reports/app-verification-report/vendor-wise-report/vendor-wise-report.component';
import { EstimationReportComponent } from './components/department/reports/estimation-report/estimation-report.component';
import { EstimationDistrictWiseReportComponent } from './components/department/reports/estimation-report/estimation-district-wise-report/estimation-district-wise-report.component';
import { EstimationMonthWiseReportComponent } from './components/department/reports/estimation-report/estimation-month-wise-report/estimation-month-wise-report.component';
import { EstimationUserWiseReportComponent } from './components/department/reports/estimation-report/estimation-user-wise-report/estimation-user-wise-report.component';
import { EstimationVendorWiseReportComponent } from './components/department/reports/estimation-report/estimation-vendor-wise-report/estimation-vendor-wise-report.component';
import { BOQReportComponent } from './components/department/reports/boq-report/boq-report.component';
import { BoqMonthWiseReportComponent } from './components/department/reports/boq-report/boq-month-wise-report/boq-month-wise-report.component';
import { BoqDistrictWiseReportComponent } from './components/department/reports/boq-report/boq-district-wise-report/boq-district-wise-report.component';
import { BoqVendorWiseReportComponent } from './components/department/reports/boq-report/boq-vendor-wise-report/boq-vendor-wise-report.component';
import { BoqMiTypeReportComponent } from './components/department/reports/boq-report/boq-mi-type-report/boq-mi-type-report.component';
import { EstimationVerificationReportComponent } from './components/department/reports/estimation-verification-report/estimation-verification-report.component';
import { EstVerificationDistrictWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-district-wise-report/est-verification-district-wise-report.component';
import { EstVerificationVendorWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-vendor-wise-report/est-verification-vendor-wise-report.component';
import { EstVerificationUserWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-user-wise-report/est-verification-user-wise-report.component';
import { EstVerificationMonthWiseReportComponent } from './components/department/reports/estimation-verification-report/est-verification-month-wise-report/est-verification-month-wise-report.component';
import { ChallanReportComponent } from './components/department/reports/challan-report/challan-report.component';
import { ChallanVendorWiseReportComponent } from './components/department/reports/challan-report/challan-vendor-wise-report/challan-vendor-wise-report.component';
import { ChallanDistrictWiseReportComponent } from './components/department/reports/challan-report/challan-district-wise-report/challan-district-wise-report.component';
import { PhysicalVerificationVendorWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-vendor-wise-report/physical-verification-vendor-wise-report.component';
import { PhysicalVerificationMonthWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-month-wise-report/physical-verification-month-wise-report.component';
import { PhysicalVerificationReportComponent } from './components/department/reports/physical-verification-report/physical-verification-report.component';
import { PhysicalVerificationDistrictWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-district-wise-report/physical-verification-district-wise-report.component';
import { PhysicalVerificationUserWiseReportComponent } from './components/department/reports/physical-verification-report/physical-verification-user-wise-report/physical-verification-user-wise-report.component';
import { FsvReportComponent } from './components/department/reports/fsv-report/fsv-report.component';
import { FsvMonthWiseReportComponent } from './components/department/reports/fsv-report/fsv-month-wise-report/fsv-month-wise-report.component';
import { FsvDistrictWiseReportComponent } from './components/department/reports/fsv-report/fsv-district-wise-report/fsv-district-wise-report.component';
import { FsvVendorWiseReportComponent } from './components/department/reports/fsv-report/fsv-vendor-wise-report/fsv-vendor-wise-report.component';
import { VendorFarmerApplicationComponent } from './components/vendor/vendor-farmer-application/vendor-farmer-application.component';
import { AllSubsidyLotComponent } from './components/department/subsidy-lot/all-subsidy-lot/all-subsidy-lot.component';
import { StvReportComponent } from './components/department/reports/stv-report/stv-report.component';
import { StvMonthWiseComponent } from './components/department/reports/stv-report/stv-month-wise/stv-month-wise.component';
import { StvVendorWiseReportComponent } from './components/department/reports/stv-report/stv-vendor-wise-report/stv-vendor-wise-report.component';
import { StfDistrictWiseReportComponent } from './components/department/reports/stf-report/stf-district-wise-report/stf-district-wise-report.component';
import { StfReportComponent } from './components/department/reports/stf-report/stf-report.component';
import { StfMonthWiseReportComponent } from './components/department/reports/stf-report/stf-month-wise-report/stf-month-wise-report.component';
import { StfVendorWiseReportComponent } from './components/department/reports/stf-report/stf-vendor-wise-report/stf-vendor-wise-report.component';
import { StvDistrictWiseReportComponent } from './components/department/reports/stv-report/stv-district-wise-report/stv-district-wise-report.component';
import { RtfReportComponent } from './components/department/reports/rtf-report/rtf-report.component';
import { RtfDistrictWiseReportComponent } from './components/department/reports/rtf-report/rtf-district-wise-report/rtf-district-wise-report.component';
import { RtfMonthWiseReportComponent } from './components/department/reports/rtf-report/rtf-month-wise-report/rtf-month-wise-report.component';
import { RtfVendorWiseReportComponent } from './components/department/reports/rtf-report/rtf-vendor-wise-report/rtf-vendor-wise-report.component';
import { VendorMiAreaReportComponent } from './components/department/reports/vendor-mi-area-report/vendor-mi-area-report.component';
import { MiVerificationSubsidyReportComponent } from './components/department/reports/mi-verification-subsidy-report/mi-verification-subsidy-report.component';
import { TankAbstractReportComponent } from './components/department/reports/tank-abstract-report/tank-abstract-report.component';
import { Stage1ReportComponent } from './components/department/reports/stage1-report/stage1-report.component';
import { Stage2ReportComponent } from './components/department/reports/stage2-report/stage2-report.component';
import { Stage3ReportComponent } from './components/department/reports/stage3-report/stage3-report.component';
import { Stage1SubsidyReportComponent } from './components/department/reports/stage1-subsidy-report/stage1-subsidy-report.component';
import { Stage3SubsidyReportComponent } from './components/department/reports/stage3-subsidy-report/stage3-subsidy-report.component';
import { Stage2SubsidyReportComponent } from './components/department/reports/stage2-subsidy-report/stage2-subsidy-report.component';
import { CanalAndTubeWellBasedReportComponent } from './components/department/reports/canal-and-tube-well-based-report/canal-and-tube-well-based-report.component';

import { ChallanMonthWiseReportComponent } from './components/department/reports/challan-report/challan-month-wise-report/challan-month-wise-report.component';
import { FarmerApplicationVerificationPendingComponent } from './components/department/farmer-application-verification/farmer-application-verification-pending/farmer-application-verification-pending.component';
import { FarmerApplicationVerificationCompletedComponent } from './components/department/farmer-application-verification/farmer-application-verification-completed/farmer-application-verification-completed.component';
import { FarmerApplicationVerificationCurrentComponent } from './components/department/farmer-application-verification/farmer-application-verification-current/farmer-application-verification-current.component';
import { YearWiseProgressComponent } from './components/department/year-wise-progress/year-wise-progress.component';
import { MiAreaCoveredComponent } from './components/department/mi-area-covered/mi-area-covered.component';
import { RealtimeDataPdmcSchemeComponent } from './components/department/realtime-data-pdmc-scheme/realtime-data-pdmc-scheme.component';
import { MiVendorApplicationVerificationPendingComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification-pending/mi-vendor-application-verification-pending.component';
import { MiVendorApplicationVerificationCurrentComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification-current/mi-vendor-application-verification-current.component';
import { MiVendorApplicationVerificationApprovedComponent } from './components/department/mi-vendor-application-verification/mi-vendor-application-verification-approved/mi-vendor-application-verification-approved.component';
// import { GeolocationComponent } from './components/geolocation/geolocation.component';
import { PreEstimateSurveyComponent } from './components/vendor/pre-estimate-survey/pre-estimate-survey.component';
import { ChallanReconciliationDayReportComponent } from './components/department/reports/challan-reconciliation-day-report/challan-reconciliation-day-report.component';
import { MiSourceLocationComponent } from './components/je/mi-source-location/mi-source-location.component';
import { MiPhysicalLocationComponent } from './components/micada_1.0/mi-physical-location/mi-physical-location.component';
import { SeventyFiveHundredDemoComponent } from './components/department/reports/seventy-five-hundred-demo/seventy-five-hundred-demo.component';
import { AtalUserComponent } from './components/department/reports/atal-user/atal-user.component';
import { MiInventoryDetailsComponent } from './components/vendor/mi-inventory-details/mi-inventory-details.component';
import { MiDaReportComponent } from './components/department/reports/da-report/mi-da-report/mi-da-report.component';
import { PondDaReportComponent } from './components/department/reports/da-report/pond-da-report/pond-da-report.component';
import { DaReportComponent } from './components/department/reports/da-report/da-report.component';
import { VendorPreEstimationReportComponent } from './components/department/reports/vendor-pre-estimation-report/vendor-pre-estimation-report.component';
import { PreEstimateMonthWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-month-wise-report/pre-estimate-month-wise-report.component';
import { PreEstimateDistrictWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-district-wise-report/pre-estimate-district-wise-report.component';
import { PreEstimateUserWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-user-wise-report/pre-estimate-user-wise-report.component';
import { PreEstimateVendorWiseReportComponent } from './components/department/reports/vendor-pre-estimation-report/pre-estimate-vendor-wise-report/pre-estimate-vendor-wise-report.component';
import { UploadGstComponent } from './components/vendor/upload-gst/upload-gst.component';
import { ImportBankDataComponent } from './components/cao/import-bank-data/import-bank-data.component';
import { OfficeOrdersComponent } from './components/office-orders/office-orders.component';
import { ConsolidatedReportComponent } from './components/department/reports/consolidated-report/consolidated-report.component';
import { PondConsolidateReportComponent } from './components/department/reports/pond-consolidate-report/pond-consolidate-report.component';
import { VendorAppApprovedComponent } from './components/vendor/vendor-application/vendor-app-approved/vendor-app-approved.component';
import { VendorAppPendingComponent } from './components/vendor/vendor-application/vendor-app-pending/vendor-app-pending.component';
import { VendorAppCurrentComponent } from './components/vendor/vendor-application/vendor-app-current/vendor-app-current.component';
import { RequestSolarComponent } from './components/dev/request-solar/request-solar.component';
import { DevGuard } from './guards/dev.guard';
import { SolarProcedureComponent } from './components/dev/solar-procedure/solar-procedure.component';
import { AddToSolarFlowComponent } from './components/dev/add-to-solar-flow/add-to-solar-flow.component';
import { ModifySolarComponent } from './components/dev/modify-solar/modify-solar.component';
import { GetSolarComponent } from './components/dev/get-solar/get-solar.component';
import { SolarListComponent } from './components/dev/solar-list/solar-list.component';
import { SubDevGuard } from './guards/sub-dev.guard';
import { ApplicationTypeReportComponent } from './components/department/application-type-report/application-type-report.component';
import { MiPhysicalVerificationCurrentComponent } from './components/je/mi-physical-verifications/mi-physical-verification-current/mi-physical-verification-current.component';
import { MiPhysicalVerficationCompletedComponent } from './components/je/mi-physical-verifications/mi-physical-verfication-completed/mi-physical-verfication-completed.component';
import { MiPhysicalVerificationPendingComponent } from './components/je/mi-physical-verifications/mi-physical-verification-pending/mi-physical-verification-pending.component';
import { SanctionLetterComponentComponent } from './components/challan/sanction-letter-component/sanction-letter-component.component';
import { ImageAttachmentsComponent } from './components/je/image-attachments/image-attachments.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: LoginComponent }],
    pathMatch: 'full',
  },
  {
    path: 'forgot-password',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: ForgotPasswordComponent }],
    pathMatch: 'full',
  },
  {
    path: 'phone-login',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: PhoneLoginComponent }],
    pathMatch: 'full',
  },

  {
    path: 'home',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: LandingComponent }],
  },
  {
    path: 'activities',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'officeOrders',
    component: HomePageLayoutComponent,
    children: [{ path: '', component: OfficeOrdersComponent }],
  },
  {
    path: 'org-setup',
    component: OrganizationalSetupComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'rti',
    component: RtiComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'statistics',
    component: StatisticsComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'new-initiatives',
    component: NewInitiativesComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'evaluation-study',
    component: EvaluationStudyComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'achievements',
    component: AchievementsComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'annual-plan',
    component: AnnualPlanComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'project',
    component: ProjectComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'micro-irrigation',
    component: MicroIrrigationComponent,
    children: [{ path: '', component: ActivitiesComponent }],
  },
  {
    path: 'dashboard',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: DashboardComponent }],
  },
  {
    path: 'pond-progress-intimation',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: PondProgressIntimationComponent }],
  },
  {
    path: 'bank-details',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: BankDetailsComponent }],
  },
  {
    path: 'personal-details',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: PersonalDetailsComponent }],
  },
  {
    path: 'farmer-land-detail',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: FarmerLandDetailComponent }],
  },
  {
    path: 'on-farm-mi',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: OnFarmMiComponent }],
  },
  {
    path: 'farmers-application',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: FarmersApplicationComponent }],
  },
  {
    path: 'farmers-application/:appId',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: FarmersApplicationComponent }],
  },
  {
    //path: 'dashboard/print:appId',
    path: 'dashboard/print/:appId/:vendorId/:programId/:userId/:autoId',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: ConsentFormComponent }],
  },
  // {
  //   path: 'farmer-applications/all-status/:id',
  //   component: InnerPageLayoutComponent,
  //   canActivate: [AuthGuard],
  //   children: [{ path: '', component: WorkFlowAllStatusComponent }],
  // },
  {
    path: 'challan',
    component: InnerPageLayoutComponent,
    children: [
      { path: '', redirectTo: 'mi-challan', pathMatch: 'full' },
      { path: 'mi-challan', component: MiChallanComponent },
      { path: 'sanction-letter/:id/:programId', component: SanctionLetterComponent },
      { path: 'farmer-share/:id/:pId', component: FarmerShareComponent },
      { path: 'full-payment/:id/:pId', component: FullPaymentComponent },
      { path: 'solar-challan', component: SolarChallanComponent },
    ],
  },
  {
    path: 'sanction',
    component: InnerPageLayoutComponent,
    children: [
      { path: '', redirectTo: 'sanctio-letter-comp', pathMatch: 'full' },
      { path: 'sanctio-letter-comp', component: SanctionLetterComponentComponent },
      { path: 'sanction-letter/:id/:programId', component: SanctionLetterComponent },
    ],
  },
  {
    path: 'change-request',
    component: InnerPageLayoutComponent,
    canActivate: [AuthGuard],
    children: [{ path: '', component: ChangeRequestComponent }],
  },
  {
    path: 'department',
    component: InnerPageLayoutComponent,
    canActivateChild: [DepartmentGuardGuard],
    children: [

      
      // {
      //   path: 'farmer-applications',
      //   component: FarmerApplicationVerificationComponent,
      // },
      {
        path: 'farmer-applications',
        component: FarmerApplicationVerificationComponent,
        
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: FarmerApplicationVerificationPendingComponent,
          },
          {
            path: 'current',
            component: FarmerApplicationVerificationCurrentComponent,
          },
          {
            path: 'approved',
            component: FarmerApplicationVerificationCompletedComponent,
          },
        ],
      },
      // { path: 'farmer-applications/all-status/:id', component: WorkFlowAllStatusComponent },
      // {
      //   path: 'vendor-mi-applications',
      //   component: MiVendorApplicationVerificationComponent,
      // },
      {
        path: 'vendor-mi-applications',
        component: MiVendorApplicationVerificationComponent,
        
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: MiVendorApplicationVerificationPendingComponent,
          },
          {
            path: 'current',
            component: MiVendorApplicationVerificationCurrentComponent,
          },
          {
            path: 'approved',
            component: MiVendorApplicationVerificationApprovedComponent,
          },
        ],
      },
      {
        path: 'pond/tank-stage1',
        component: TankStage1Component,
      },
      {
        path: 'pond/tank-stage2',
        component: TankStage2Component,
      },
      {
        path: 'pond/tank-stage3',
        component: TankStage3Component,
      },
      {
        path: 'print-farmer-bank-challan',
        component: PrintFarmersChallanComponent,
      },
      {
        path: 'approve-farmer-bank-challan',
        component: ApproveFarmersChallanComponent,
      },
      {
        path: 'year-wise-progress',
        component : YearWiseProgressComponent
      },
      {
        path: 'mi-area-covered',
        component : MiAreaCoveredComponent
      },
      {
        path: 'realtime-data-pdmc-scheme',
        component: RealtimeDataPdmcSchemeComponent
      },
      {
        path: 'vendor-estimate/print/:appId/:vendorId/:programId',
        component: VendorMiEstimationConsentFormComponent,
      },
      {
        path: 'appliaction-approval/print/:appId',
        ///:vendorId/:programId/:userId/:autoId
        component: DepartmentConsentFormComponent,
      },
      // {
      //   path: 'print/:appId',
      //   ///:vendorId/:programId/:userId/:autoId
      //   component: DepartmentConsentFormComponent,
      // },
      {
        path: 'report-summary',
        component: ReportSummaryComponent,
      },
      {
        path:'helpdesk',
        component: HelpdeskComponent,
      },
      {
        path: 'helpdesk/:appId',
        component: ConsentFormComponent,
      },
      {
        path: 'mi-survey',
        component: MiSurveyComponent,
      },
      {
        path: 'farmer-share-to-vendor',
        component: FarmerShareToVendorComponent,
      },
      {
        path: 'subsidy-to-vendor',
        component: SubsidyToVendorComponent,
      },
      {
        path: 'subsidy-to-farmer',
        component: SubsidyToFarmerComponent,
      },
      {
        path: 'refund-to-farmer',
        component: RefundToFarmerComponent,
      },
      {
        path: 'update-mi-component-cml-validity',
        component: UpdateMiComponentCmlValidityComponent,
      },
      // {
      //   path: 'physical-verification',
      //   component: MiPhysicalVerificationsComponent,
      // },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path:'pond/tankstage-1',
        component: Tankstagesurvey1Component,
      },
      {
        path:'pond/tankstage-2',
        component: Tankstagesurvey2Component,
      },
      {
        path:'pond/tankstage-3',
        component: Tankstagesurvey3Component,
      },
      {
        path:'dashboard',
        component: DepartmentDashboardComponent,
      },
      {
        path: 'dashboard/micada_geography',
        component: DepartmentDashboardComponent,
        pathMatch: 'full'
      },
      {
        path: 'dashboard/vendor_metrics',
        component: DepartmentDashboardComponent,
        pathMatch: 'full'
      },
      {
        path: 'dashboard/app_verification',
        component: DepartmentDashboardComponent,
        pathMatch: 'full'
      },
      {
        path: 'application',
        component: JeApplicationComponent,
        children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
          { path: 'image-attachment', component: ImageAttachmentsComponent },
        ],
      },
      { path: 'change-request', component: FarmerAppChangeRequestComponent },
      { path: 'maps', component: ViewCoOrdinatesComponent, pathMatch: 'full' },
      {
        path: 'report/app-verification',
        component: AppVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: MonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: DistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: UserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: VendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation',
        component: EstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'estimation-month-wise', pathMatch: 'full' },
          {
            path: 'estimation-month-wise',
            component: EstimationMonthWiseReportComponent,
          },
          {
            path: 'estimation-district-wise',
            component: EstimationDistrictWiseReportComponent,
          },
          {
            path: 'estimation-user-wise',
            component: EstimationUserWiseReportComponent,
          },
          {
            path: 'estimation-vendor-wise',
            component: EstimationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/boq',
        component: BOQReportComponent,
        
        children: [
          { path: '', redirectTo: 'boq-month-wise', pathMatch: 'full' },
          {
            path: 'boq-month-wise',
            component: BoqMonthWiseReportComponent,
          },
          {
            path: 'boq-district-wise',
            component: BoqDistrictWiseReportComponent,
          },
          {
            path: 'boq-mi-type',
            component: BoqMiTypeReportComponent,
          },
          {
            path: 'boq-vendor-wise',
            component: BoqVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation-verification',
        component: EstimationVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: EstVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: EstVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: EstVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: EstVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/challan',
        component: ChallanReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: ChallanDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: ChallanVendorWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: ChallanMonthWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/physical-verification',
        component: PhysicalVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PhysicalVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PhysicalVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PhysicalVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PhysicalVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/fsv',
        component: FsvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: FsvMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: FsvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: FsvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stv',
        component: StvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: StvMonthWiseComponent,
          },
          {
            path: 'district-wise',
            component: StvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stf',
        component: StfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: StfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: StfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/rtf',
        component: RtfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: RtfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: RtfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: RtfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/mi-verification-subsidy-report',
        component: MiVerificationSubsidyReportComponent,     
      },
      {
        path: 'report/vendor-mi-area-report',
        component: VendorMiAreaReportComponent,

      },
      {
        path: 'report/tank-abstract-report',
        component: TankAbstractReportComponent,     
      },
      {
        path: 'report/stage1-report',
        component: Stage1ReportComponent,
        
      },
      {
        path: 'report/stage2-report',
        component: Stage2ReportComponent,
        
      },
      {
        path: 'report/stage3-report',
        component: Stage3ReportComponent,
        
      },
      {
        path: 'report/stage1-subsidy-report',
        component: Stage1SubsidyReportComponent,
        
      },
      {
        path: 'report/stage2-subsidy-report',
        component: Stage2SubsidyReportComponent,
        
      },
      {
        path: 'report/stage3-subsidy-report',
        component: Stage3SubsidyReportComponent,
        
      },
      {
        path: 'report/canal-and-tube-well-based-report',
        component: CanalAndTubeWellBasedReportComponent,
        
      },
      {
        path: 'report/7500-demo',
        component: SeventyFiveHundredDemoComponent,
        
      },
      {
        path: 'report/atal-bhujal-user',
        component: AtalUserComponent,
        
      },
      {
        path: 'all-subsidy-lot',
        component: AllSubsidyLotComponent,
        
        children: [
          
          { path: 'mi-farmer-share-to-vendor/pfms', component: FarmerShareToVendorPfmsReportComponent,  },
          { path: 'mi-subsidy-to-farmer/pfms', component: SubsidyToFarmerPfmsReportComponent,  },
          { path: 'mi-subsidy-to-vendor/pfms', component: SubsidyToVendorPfmsReportComponent, },
          { path: 'mi-refund-to-farmer/pfms', component: ReturnToFarmerPfmsReportComponent,  },
          { path: 'import/pfms', component: ImportPfmsDataComponent,  },
          
          {
            path: 'pond/tank-stage1/pfms',
            component: TankStage1PfmsReportComponent,
            
          },
          {
            path: 'pond/tank-stage2/pfms',
            component: TankStage2PfmsReportComponent,
            
          },
          {
            path: 'pond/tank-stage3/pfms',
            component: TankStage3PfmsReportComponent,
            
          },
        ],
      },
      {
        path: 'report/chalan-reconciliation-day-report',
        component: ChallanReconciliationDayReportComponent,     
      },
      {
        path: 'mi-physical-location',
        component: MiPhysicalLocationComponent
      },
     
      {
        path: 'report/da-report',
        component: DaReportComponent,
        
        children: [
          // { path: '', redirectTo: 'mi', pathMatch: 'full' },
          {
            path: 'mi',
            component: MiDaReportComponent,
          },
          {
            path: 'pond',
            component: PondDaReportComponent,
          },
         
        ],
      },
      {
        path: 'report/pre-estimation',
        component: VendorPreEstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PreEstimateMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PreEstimateDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PreEstimateUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PreEstimateVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/consolidated-report',
        component: ConsolidatedReportComponent,
      },
      {
        path: 'report/pond-consolidated-report',
        component: PondConsolidateReportComponent, 
      },
      {
        path: 'report/timeline',
        component: ApplicationTypeReportComponent
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: DepartmentConsentFormComponent,
      },
    ],
    
  },
  {
    path: 'vendor',
    component: InnerPageLayoutComponent,
    canActivateChild: [VendorGuardGuard],
    children: [
      { path: '', redirectTo: 'pre-estimate-survey', pathMatch: 'full' },
      { path: 'dashboard', component: VendorComponent },
      {
        path: 'vendor-farmer-application',
        component: VendorFarmerApplicationComponent,
      },
      {
        path: 'vendor-BOQ',
        component: VendorBOQComponent,
      },
      {
        path: 'vendor-application',
        component: VendorApplicationComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          {
            path: 'pending',
            component: VendorAppPendingComponent,
          },
          {
            path: 'approved',
            component: VendorAppApprovedComponent,
          },
          {
            path: 'current',
            component: VendorAppCurrentComponent,
          },
          
         
        ],
      },
      {
        path: 'vendor-FullPaymentChallanDetails',
        component: FullPaymentchallanDetailsComponent,
      },
      // {
      //   path: 'print/:appId/:vendorId/:programId',
      //   component: VendorConsentFormComponent,
      // },
      {
        path: 'print/:appId',
        component: VendorConsentFormComponent,
      },
      {
        path: 'report/vendor-mi-area-report',
        component: VendorMiAreaReportComponent,

      },
      {
        path: 'report/estimation',
        component: EstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'estimation-month-wise', pathMatch: 'full' },
          {
            path: 'estimation-month-wise',
            component: EstimationMonthWiseReportComponent,
          },
          {
            path: 'estimation-district-wise',
            component: EstimationDistrictWiseReportComponent,
          },
          {
            path: 'estimation-user-wise',
            component: EstimationUserWiseReportComponent,
          },
          {
            path: 'estimation-vendor-wise',
            component: EstimationVendorWiseReportComponent,
          },
        ],
      },
      {
        path: 'pre-estimate-survey',
        component: PreEstimateSurveyComponent,

      },
      {
        path:'mi-component-inventory-details',
        component: MiInventoryDetailsComponent
      },
      {
        path:'upload-gst-details',
        component: UploadGstComponent
      }
    ],
  },
  {
    path: 'je',
    component: InnerPageLayoutComponent,
    canActivateChild: [JEGuardGuard],
    children: [
      // { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      // { path: 'dashboard', component: PondEstimateComponent },
     { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },
    {
      path: 'physical-verification',
      component: MiPhysicalVerificationsComponent,
      children: [
        { path: '', redirectTo: 'pending', pathMatch: 'full' },
        { path: 'pending', component: MiPhysicalVerificationPendingComponent },
        { path: 'current', component: MiPhysicalVerificationCurrentComponent },
        { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
      ],
    },
      // {
      //   path: 'physical-verification',
      //   component: MiPhysicalVerificationsComponent,
      // },
      // {
      //   path: 'physical-verification/:appId/:vendorId/:programId/:userId/:autoId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
        {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'je/tank-stage1',
        component: TankStage1Component,
      },
      {
        path: 'je/tank-stage2',
        component: TankStage2Component,
      },
      // {
      //   path: 'je/tank-stage3',
      //   component: TankStage3Component,
      // },
      {
        path: 'application',
        component: JeApplicationComponent,
        children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ],
      },
      // {
      //   path: 'print/:appId', component: VendorConsentFormComponent,
      // }
      {
        path: 'mi-source-location',
        component: MiSourceLocationComponent
      }
    ],
  },

  {
    path: 'cje',
    component: InnerPageLayoutComponent,
    canActivateChild: [JEGuardGuard],
    children: [
     { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },
    //  { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
    {
      path: 'physical-verification',
      component: MiPhysicalVerificationsComponent,
      children: [
        { path: '', redirectTo: 'pending', pathMatch: 'full' },
        { path: 'pending', component: MiPhysicalVerificationPendingComponent },
        { path: 'current', component: MiPhysicalVerificationCurrentComponent },
        { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
      ],
    },
     {
      path: 'print/:appId',
      component: ConsentFormComponent,
    }, 
    {
      path: 'application',
      component: JeApplicationComponent,
      children: [
        { path: '', redirectTo: 'basic', pathMatch: 'full' },
        { path: 'basic', component: BasicComponent },
        { path: 'finance', component: FinanceComponent },
        { path: 'attachment', component: AttachmentComponent },
      ],
    },
    ],
  },

  {
    path: 'sdo',
    component: InnerPageLayoutComponent,
    canActivateChild: [SdoGuardGuard],
    children: [
      { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },

      // { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      // {
      //   path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
      //   component: ConsentFormComponent,
      // },
      {
        path: 'print/:appId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'sdo/tank-stage1',
        component: TankStage1Component,
      },
      {
        path: 'sdo/tank-stage2',
        component: TankStage2Component,
      },
      // {
      //   path: 'sdo/tank-stage3',
      //   component: TankStage3Component,
      // },
      {
        path: 'application', component: JeApplicationComponent, children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ]
      },

      {
        path: 'view-form',
        component: ViewFormComponent,
      },
    ],
  },
  {
    path: 'xen',
    component: InnerPageLayoutComponent,
    canActivateChild: [XenGuardGuard],
    children: [
      { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },

      // { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'print/:appId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'xen/tank-stage1',
        component: TankStage1Component,
      },
      {
        path: 'xen/tank-stage2',
        component: TankStage2Component,
      },
      // {
      //   path: 'xen/tank-stage3',
      //   component: TankStage3Component,
      // },
      {
        path: 'application', component: JeApplicationComponent, children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ]
      },

      {
        path: 'view-form',
        component: ViewFormComponent,
      },
      {
        path:'helpdesk',
        component: HelpdeskComponent,
      },
      {
        path: 'helpdesk/:appId',
        component: ConsentFormComponent,
      },
      {
        path: 'report/app-verification',
        component: AppVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: MonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: DistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: UserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: VendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation',
        component: EstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'estimation-month-wise', pathMatch: 'full' },
          {
            path: 'estimation-month-wise',
            component: EstimationMonthWiseReportComponent,
          },
          {
            path: 'estimation-district-wise',
            component: EstimationDistrictWiseReportComponent,
          },
          {
            path: 'estimation-user-wise',
            component: EstimationUserWiseReportComponent,
          },
          {
            path: 'estimation-vendor-wise',
            component: EstimationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/boq',
        component: BOQReportComponent,
        
        children: [
          { path: '', redirectTo: 'boq-month-wise', pathMatch: 'full' },
          {
            path: 'boq-month-wise',
            component: BoqMonthWiseReportComponent,
          },
          {
            path: 'boq-district-wise',
            component: BoqDistrictWiseReportComponent,
          },
          {
            path: 'boq-mi-type',
            component: BoqMiTypeReportComponent,
          },
          {
            path: 'boq-vendor-wise',
            component: BoqVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation-verification',
        component: EstimationVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: EstVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: EstVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: EstVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: EstVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/challan',
        component: ChallanReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: ChallanDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: ChallanVendorWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: ChallanMonthWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/physical-verification',
        component: PhysicalVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PhysicalVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PhysicalVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PhysicalVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PhysicalVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/fsv',
        component: FsvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: FsvMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: FsvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: FsvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stv',
        component: StvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: StvMonthWiseComponent,
          },
          {
            path: 'district-wise',
            component: StvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stf',
        component: StfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: StfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: StfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/rtf',
        component: RtfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: RtfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: RtfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: RtfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/mi-verification-subsidy-report',
        component: MiVerificationSubsidyReportComponent,     
      },
      {
        path: 'report/vendor-mi-area-report',
        component: VendorMiAreaReportComponent,

      },
      {
        path: 'report/tank-abstract-report',
        component: TankAbstractReportComponent,     
      },
      {
        path: 'report/stage1-report',
        component: Stage1ReportComponent,
        
      },
      {
        path: 'report/stage2-report',
        component: Stage2ReportComponent,
        
      },
      {
        path: 'report/stage3-report',
        component: Stage3ReportComponent,
        
      },
      {
        path: 'report/stage1-subsidy-report',
        component: Stage1SubsidyReportComponent,
        
      },
      {
        path: 'report/stage2-subsidy-report',
        component: Stage2SubsidyReportComponent,
        
      },
      {
        path: 'report/stage3-subsidy-report',
        component: Stage3SubsidyReportComponent,
        
      },
      {
        path: 'report/canal-and-tube-well-based-report',
        component: CanalAndTubeWellBasedReportComponent,

      },
      {
        path: 'mi-physical-location',
        component: MiPhysicalLocationComponent
      },
      {
        path: 'report/7500-demo',
        component: SeventyFiveHundredDemoComponent,
      },
      {
        path: 'report/atal-bhujal-user',
        component: AtalUserComponent,
      },
    ],
  },
  {
    path: 'cxen',
    component: InnerPageLayoutComponent,
    canActivateChild: [XenGuardGuard],
    children: [
      { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },

      // { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: ConsentFormComponent,
      }, 
      {
        path: 'print/:appId',
        component: ConsentFormComponent,
      },
      {
        path: 'application', component: JeApplicationComponent, children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ]
      },

      {
        path: 'view-form',
        component: ViewFormComponent,
      },
    ]
  },
  {
    path: 'admin',
    component: InnerPageLayoutComponent,
    children: [
      { path: '', redirectTo: 'physical-verification', pathMatch: 'full' },

      // { path: 'physical-verification', component: MiPhysicalVerificationsComponent },
      {
        path: 'physical-verification',
        component: MiPhysicalVerificationsComponent,
        children: [
          { path: '', redirectTo: 'pending', pathMatch: 'full' },
          { path: 'pending', component: MiPhysicalVerificationPendingComponent },
          { path: 'current', component: MiPhysicalVerificationCurrentComponent },
          { path: 'approved', component: MiPhysicalVerficationCompletedComponent },
        ],
      },
      {
        path: 'pond/tank-stage1',
        component: TankStage1Component,
      },
      {
        path: 'pond/tank-stage2',
        component: TankStage2Component,
      },
      {
        path: 'pond/tank-stage3',
        component: TankStage3Component,
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'year-wise-progress',
        component : YearWiseProgressComponent
      },
      {
        path: 'mi-area-covered',
        component : MiAreaCoveredComponent
      },
      {
        path: 'realtime-data-pdmc-scheme',
        component: RealtimeDataPdmcSchemeComponent
      },
      {
        path: 'application', component: JeApplicationComponent, children: [
          { path: '', redirectTo: 'basic', pathMatch: 'full' },
          { path: 'basic', component: BasicComponent },
          { path: 'finance', component: FinanceComponent },
          { path: 'attachment', component: AttachmentComponent },
        ]
      },

      {
        path: 'view-form',
        component: ViewFormComponent,
      },

      {
        path: 'sdo/tank-stage1',
        component: TankStage1Component,
      },

      {
        path: 'sdo/tank-stage2',
        component: TankStage2Component,
      },

      {
        path: 'sdo/tank-stage3',
        component: TankStage3Component,
      },
      {
        path: 'report/app-verification',
        component: AppVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: MonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: DistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: UserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: VendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation',
        component: EstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'estimation-month-wise', pathMatch: 'full' },
          {
            path: 'estimation-month-wise',
            component: EstimationMonthWiseReportComponent,
          },
          {
            path: 'estimation-district-wise',
            component: EstimationDistrictWiseReportComponent,
          },
          {
            path: 'estimation-user-wise',
            component: EstimationUserWiseReportComponent,
          },
          {
            path: 'estimation-vendor-wise',
            component: EstimationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/boq',
        component: BOQReportComponent,
        
        children: [
          { path: '', redirectTo: 'boq-month-wise', pathMatch: 'full' },
          {
            path: 'boq-month-wise',
            component: BoqMonthWiseReportComponent,
          },
          {
            path: 'boq-district-wise',
            component: BoqDistrictWiseReportComponent,
          },
          {
            path: 'boq-mi-type',
            component: BoqMiTypeReportComponent,
          },
          {
            path: 'boq-vendor-wise',
            component: BoqVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/estimation-verification',
        component: EstimationVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: EstVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: EstVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: EstVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: EstVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/challan',
        component: ChallanReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: ChallanDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: ChallanVendorWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: ChallanMonthWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/physical-verification',
        component: PhysicalVerificationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PhysicalVerificationMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PhysicalVerificationDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PhysicalVerificationUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PhysicalVerificationVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/fsv',
        component: FsvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: FsvMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: FsvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: FsvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stv',
        component: StvReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: StvMonthWiseComponent,
          },
          {
            path: 'district-wise',
            component: StvDistrictWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StvVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/stf',
        component: StfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: StfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: StfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: StfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/rtf',
        component: RtfReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'district-wise',
            component: RtfDistrictWiseReportComponent,
          },
          {
            path: 'month-wise',
            component: RtfMonthWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: RtfVendorWiseReportComponent,
          },
         
        ],
      },
      {
        path: 'report/mi-verification-subsidy-report',
        component: MiVerificationSubsidyReportComponent,     
      },
      {
        path: 'report/vendor-mi-area-report',
        component: VendorMiAreaReportComponent,

      },
      {
        path: 'report/tank-abstract-report',
        component: TankAbstractReportComponent,     
      },
      {
        path: 'report/stage1-report',
        component: Stage1ReportComponent,
        
      },
      {
        path: 'report/stage2-report',
        component: Stage2ReportComponent,
        
      },
      {
        path: 'report/stage3-report',
        component: Stage3ReportComponent,
        
      },
      {
        path: 'report/stage1-subsidy-report',
        component: Stage1SubsidyReportComponent,
        
      },
      {
        path: 'report/stage2-subsidy-report',
        component: Stage2SubsidyReportComponent,
        
      },
      {
        path: 'report/stage3-subsidy-report',
        component: Stage3SubsidyReportComponent,
        
      },
      {
        path: 'report/canal-and-tube-well-based-report',
        component: CanalAndTubeWellBasedReportComponent,
        
      },
      {
        path: 'report/chalan-reconciliation-day-report',
        component: ChallanReconciliationDayReportComponent,     
      },
      {
        path: 'report/7500-demo',
        component: SeventyFiveHundredDemoComponent,
      },
      {
        path: 'report/atal-bhujal-user',
        component: AtalUserComponent,
      },
      {
        path: 'report/pre-estimation',
        component: VendorPreEstimationReportComponent,
        
        children: [
          { path: '', redirectTo: 'month-wise', pathMatch: 'full' },
          {
            path: 'month-wise',
            component: PreEstimateMonthWiseReportComponent,
          },
          {
            path: 'district-wise',
            component: PreEstimateDistrictWiseReportComponent,
          },
          {
            path: 'user-wise',
            component: PreEstimateUserWiseReportComponent,
          },
          {
            path: 'vendor-wise',
            component: PreEstimateVendorWiseReportComponent,
          },
        ],
      },
      {
        path: 'report/consolidated-report',
        component: ConsolidatedReportComponent,
        
        
      },
      {
        path: 'report/pond-consolidated-report',
        component: PondConsolidateReportComponent,
        
        
      },
      {
        path: 'report/timeline',
        component: ApplicationTypeReportComponent
      }  
    ],
  },

  {
    path: 'xen',
    component: InnerPageLayoutComponent,
    canActivateChild: [XenGuardGuard],
    children: [
      { path: '', redirectTo: 'xen', pathMatch: 'full' },

      {
        path: 'xen',
        component: XenComponent,
      },
      
      {
        path: 'xen/xen-form',
        component: XenFormComponent,
      },

      {
        path: 'xen/tank-stage1',
        component: TankStage1Component,
      },

      {
        path: 'xen/tank-stage2',
        component: TankStage2Component,
      },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },

      // {
      //   path: 'xen/tank-stage3',
      //   component: TankStage3Component,
      // },
    ],
  },
  {
    path: 'helpdesk',
    component: InnerPageLayoutComponent,
    canActivateChild: [HelpdeskGuard],
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HelpdeskComponent,
      },
      {
        path: 'home/:appId',
        component: ConsentFormComponent,
      },
    ],
  },
  {
    path: 'cao',
    component: InnerPageLayoutComponent,
    canActivateChild: [CAOGuardGuard],
    children: [
      { path: '', redirectTo: 'mi-farmer-share-to-vendor/pfms', pathMatch: 'full' },
      { path: 'mi-farmer-share-to-vendor/pfms', component: FarmerShareToVendorPfmsReportComponent, pathMatch: 'full' },
      { path: 'mi-subsidy-to-farmer/pfms', component: SubsidyToFarmerPfmsReportComponent, pathMatch: 'full' },
      { path: 'mi-subsidy-to-vendor/pfms', component: SubsidyToVendorPfmsReportComponent, pathMatch: 'full' },
      { path: 'mi-refund-to-farmer/pfms', component: ReturnToFarmerPfmsReportComponent, pathMatch: 'full' },
      { path: 'import/pfms', component: ImportPfmsDataComponent, pathMatch: 'full' },
      { path: 'import/bank-transaction', component: ImportBankDataComponent, pathMatch: 'full' },
      {
        path: 'print/:appId',
        component: ViewFarmerApplicationComponent,
      },
      {
        path: 'print/:appId/:vendorId/:programId/:userId/:autoId',
        component: DepartmentConsentFormComponent,
      },
      {
        path: 'pond/tank-stage1/pfms',
        component: TankStage1PfmsReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage2/pfms',
        component: TankStage2PfmsReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'pond/tank-stage3/pfms',
        component: TankStage3PfmsReportComponent,
        pathMatch: 'full'
      },
      {
        path: 'report/chalan-reconciliation-day-report',
        component: ChallanReconciliationDayReportComponent,     
      },
      {
        path:'helpdesk',
        component: HelpdeskComponent,
      },
      {
        path: 'helpdesk/:appId',
        component: ConsentFormComponent,
      },
    ],
  },
  {
    path: 'dev',
    component: InnerPageLayoutComponent,
    canActivateChild: [DevGuard],
    children: [
      { path: '', redirectTo: 'request-solar', pathMatch: 'full' },
      { path: 'request-solar', component: RequestSolarComponent, pathMatch: 'full' },
      { path: 'solar-procedure', component: SolarProcedureComponent, pathMatch: 'full' },
      { path: 'solar-flow', component: AddToSolarFlowComponent, pathMatch: 'full' },
      { path: 'modify-solar', component: ModifySolarComponent, pathMatch: 'full' },
      { path: 'get-solar', component: GetSolarComponent, pathMatch: 'full' },
      { path: 'solar-list', component: SolarListComponent, pathMatch: 'full' }
    ]
  },
  {
    path: 'subdev',
    component: InnerPageLayoutComponent,
    canActivateChild: [SubDevGuard],
    children: [
      { path: '', redirectTo: 'request-solar', pathMatch: 'full' },
      { path: 'request-solar', component: RequestSolarComponent, pathMatch: 'full' },
      { path: 'solar-flow', component: AddToSolarFlowComponent, pathMatch: 'full' },
      { path: 'get-solar', component: GetSolarComponent, pathMatch: 'full' },
    ]
  },
  
  // {
  //   path: 'geo-location',
  //   component: GeolocationComponent
  // },
  {
    path: "", redirectTo: "/home", pathMatch: "full"
  },
  {
    path: "**", redirectTo: "/home", pathMatch: "full"
  }
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
